<div class="animate-fade-in space-y-8 p-8">
  <div class="flex flex-col gap-1">
    <h1 class="text-3xl font-serif text-heading">Dynamic QR Code Manager</h1>
    <p class="text-muted text-sm leading-relaxed max-w-2xl">
      These QR codes point to a permanent "Bridge URL". You can change their destination in Firestore
      without reprinting.
    </p>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    <div *ngFor="let qr of redirects" class="bg-white border border-[#E5DDD5] p-8 rounded-sm shadow-sm hover:shadow-md transition-all flex flex-col items-center gap-6">
      <h3 class="font-serif text-heading text-lg tracking-wide border-b border-btn/30 pb-2 w-full text-center">{{ qr.name }}</h3>
      <div [id]="'qr-' + qr.id" class="p-4 bg-section border border-[#E5DDD5] rounded-sm">
        <qrcode [qrdata]="getRedirectUrl(qr.id)" [width]="200" [errorCorrectionLevel]="'M'">
        </qrcode>
      </div>
      <div class="w-full">
        <p class="text-[10px] text-muted uppercase tracking-[0.2em] mb-1">Bridge URL</p>
        <code class="block w-full p-2 bg-section text-body-text rounded-sm border border-[#E5DDD5] text-[10px] break-all">{{ getRedirectUrl(qr.id) }}</code>
      </div>
      <button 
        (click)="printQR(qr.id)" 
        class="w-full py-3 bg-heading text-white font-serif uppercase text-xs tracking-widest hover:bg-[#1A2E22] transition-all duration-500 shadow-sm"
      >
        Print Ritual Key
      </button>
    </div>
  </div>
</div>
